import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { LOGO_URL } from "@/config";

export const TermsOfServicePage = () => (
  <div className="min-h-screen bg-background">
    <nav className="fixed top-0 w-full z-50 glass">
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3"><img src={LOGO_URL} alt="Creatara - Terms of Service for AI Content Platform" className="w-10 h-10 rounded-lg" /><span className="text-xl font-bold">Creatara</span></Link>
        <Link to="/"><Button variant="ghost">Home</Button></Link>
      </div>
    </nav>
    <div className="pt-24 pb-12 px-6">
      <div className="max-w-3xl mx-auto prose prose-invert">
        <h1 className="text-4xl font-bold mb-8">Terms of Service</h1>
        <p className="text-muted-foreground mb-4">Last updated: March 2026</p>
        
        <h2 className="text-2xl font-semibold mt-8 mb-4">1. Agreement to Terms</h2>
        <p className="text-muted-foreground mb-4">By accessing Creatara, you agree to be bound by these Terms of Service. If you do not agree, please do not use our service.</p>
        
        <h2 className="text-2xl font-semibold mt-8 mb-4">2. Description of Service</h2>
        <p className="text-muted-foreground mb-4">Creatara provides AI-powered content generation, affiliate link management, lead capture, and related marketing tools.</p>
        
        <h2 className="text-2xl font-semibold mt-8 mb-4">3. User Accounts</h2>
        <p className="text-muted-foreground mb-4">You must provide accurate information when creating an account. You are responsible for maintaining the security of your account and all activities under it.</p>
        
        <h2 className="text-2xl font-semibold mt-8 mb-4">4. Subscription Plans & Payments</h2>
        <p className="text-muted-foreground mb-4">We offer Free, Pro (£29/month), and Enterprise (£99/month) plans. Payments are processed securely via Stripe. Subscriptions renew automatically unless cancelled.</p>
        
        <h2 className="text-2xl font-semibold mt-8 mb-4">5. Content Ownership</h2>
        <p className="text-muted-foreground mb-4">You retain ownership of content you create using our platform. You grant us a limited licence to host and display your content for service delivery purposes.</p>
        
        <h2 className="text-2xl font-semibold mt-8 mb-4">6. Acceptable Use</h2>
        <p className="text-muted-foreground mb-4">You agree not to: use the service for illegal purposes, generate harmful or misleading content, attempt to access other users' accounts, or overload our systems.</p>
        
        <h2 className="text-2xl font-semibold mt-8 mb-4">7. AI-Generated Content</h2>
        <p className="text-muted-foreground mb-4">Content generated by our AI is provided "as is". You are responsible for reviewing and editing content before publishing. We do not guarantee accuracy or suitability.</p>
        
        <h2 className="text-2xl font-semibold mt-8 mb-4">8. Limitation of Liability</h2>
        <p className="text-muted-foreground mb-4">To the maximum extent permitted by law, ProJohnson Consulting Ltd shall not be liable for any indirect, incidental, or consequential damages arising from your use of the service.</p>
        
        <h2 className="text-2xl font-semibold mt-8 mb-4">9. Termination</h2>
        <p className="text-muted-foreground mb-4">We reserve the right to suspend or terminate accounts that violate these terms. You may cancel your subscription at any time.</p>
        
        <h2 className="text-2xl font-semibold mt-8 mb-4">10. Changes to Terms</h2>
        <p className="text-muted-foreground mb-4">We may update these terms from time to time. Continued use of the service constitutes acceptance of updated terms.</p>
        
        <h2 className="text-2xl font-semibold mt-8 mb-4">11. Governing Law</h2>
        <p className="text-muted-foreground mb-4">These terms are governed by the laws of England & Wales. Any disputes shall be resolved in the courts of England & Wales.</p>
        
        <h2 className="text-2xl font-semibold mt-8 mb-4">12. Contact</h2>
        <p className="text-muted-foreground mb-4">For questions about these terms: support@creatara.ai</p>
      </div>
    </div>
  </div>
);
